import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Text from "./Text"
import { colourFromProps } from "./theme"

const Container = styled.button`
  padding: 0.3rem;
  font-size: 1rem;
  font-weight: normal;
  background: transparent;
  font-weight: normal;
  border: none;
  color: ${colourFromProps},
  border-radius: ${(props) => props.theme.corners};
  cursor: pointer;
  box-shadow: none;
  // Default space between adjacent buttons
  & + button,
  & + input {
    margin-left: 0.5rem;
  }
`

const Button = (props) => (
  <Container {...props}>
    <Text {...props}>
      <FontAwesomeIcon icon={props.icon} />
    </Text>
  </Container>
)

Button.propTypes = {
  icon: PropTypes.any,
}

export default Button
